<template>
  <div>
    <el-row>
      <TableContainer
        expand
        CustomTableArticle
        :FilterStatusDefault="false"
        :columns="containerTableColumns"
        :serverUrl="containerServerUrl"
        :baseUrl="containerBaseUrl"
        :tableToolConfig="tableToolConfig"
        searchPlaceHolder="可根据地址进行搜索"
        :showReviewOption="false"
        ref="TableContainer"
      >
        <template v-slot:tools>
          <!-- <router-link :to="'/schedulingStart'">
            <el-button type="primary" icon="el-icon-circle-plus-outline">开始排课</el-button>
          </router-link>-->
        </template>

        <template v-slot:expand="{props}">
          <div class="table_expand">
            <div class="table_expand__title">绑定的课程</div>
            <template v-for="item in props.row.courses">
              <div class="table_expand__item" :key="item.title">
                <div class="table_expand__title">
                  <b>课程名：</b>
                  {{item.title}}
                </div>
                <div class="table_expand__teacher">
                  <b>讲师：</b>
                  {{item.teacher}}
                </div>
              </div>
            </template>
            <template v-if="props.row.courses.length == 0">
              <p class="font_asset">无绑定的课程</p>
            </template>
          </div>
        </template>

        <template v-slot:filter>
          <div class="flex">
            <StudyClassSelect @onValueChanged="onStudyClassValueChanged"></StudyClassSelect>
            <UnitCascader v-if="isAdmin" @onValueChanged="onUnitValueChanged" class="ml-5"></UnitCascader>
            <PartyOrgCascader v-if="isAdmin" @onValueChanged="onPartyOrgValueChanged" class="ml-5"></PartyOrgCascader>
            <el-button type="primary" size="small" plain @click="goFillCheckApplyPage(props)" class="ml-5">查看申请补签列表</el-button>
          </div>
        </template>

        <template v-slot:columnSlotTool="{props}">
          <el-button type="primary" size="small" plain @click="goFillCheckPage(props)">补签</el-button>
        </template>

        <!--  -->
        <template v-slot:table__footer__info>排课列表</template>
      </TableContainer>

      <!-- <el-row>
          <p class="paragraph-content-small grey asset"><i class="el-icon-info"></i> 当前列表项的显示顺序，即是网站相关项目的显示顺序。</p>
      </el-row>-->
    </el-row>
  </div>
</template>


<script>

import { TableContainer } from "@/core/table/";
import { StudyClassSelect,UnitCascader,PartyOrgCascader } from "@/views/components/select";

export default {
  name: "fill-check",
  components : {
    TableContainer,
    StudyClassSelect,
    UnitCascader,
    PartyOrgCascader
  },
  data() {
    return {
      isAdmin : false,

      containerTableColumns : [
        {
          prop: "displayDate",
          label: "排课日期",
          width: "200px",
        },
        {
          prop: "addresses",
          label: "上课地址",
          width: "400px",
        },
        {
          prop: "sctitle",
          label: "所属学习班",
          width: "200px",
        },
        {
          prop: "credithour",
          label: "学时",
          width: "50px",
        },
      ],
      // 基础地址
      containerBaseUrl : "/standard/scheduling",
      // api的基础地址
      // eslint-disable-next-line no-undef
      containerServerUrl :  "/api/manager/scheduling",
      // table config 设置
      tableToolConfig : {
        canEdit: false,
        canRecover: false,
        canDelete: false,
        canDisable: false,
      }
    }
  },
  methods : {
    onStudyClassValueChanged(sid) {
      this.$refs.TableContainer.updateSid(sid);
    },
    goFillCheckPage(id) {
      const { href } = this.$router.resolve({
        path: `detail`,
        query: {
          id: id,
        },
      });

      window.open(href, "_blank");
    },
    goFillCheckApplyPage(id){
      this.$router.push({
        path : '/fillcheck/apply'
      })
    },
    onUnitValueChanged(ids){
      this.$refs.TableContainer.updateParams("units",ids);
    },

    onPartyOrgValueChanged(ids){
      this.$refs.TableContainer.updateParams("partyids",ids);
    }
  },
  mounted(){    
    let isA = this.$store.getters['profileModule/isadmin'];
    let isJ = this.$store.getters['profileModule/isjdx'];
    let isS = this.$store.getters['profileModule/isjdx'];

    this.isAdmin = isA || isJ || isS

  }
}



</script>







<style scoped>
</style>